<template>
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '提醒信息'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="110px" :rules="rules">
      <el-form-item label="提醒名称" prop="Name">
        <el-input
          v-model.trim="item.Name"
          placeholder="请输入提醒名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="提醒编码" prop="Code">
        <el-input
          v-model.trim="item.Code"
          placeholder="请输入提醒编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="钉钉关键词" prop="Keyword">
        <el-input
          v-model.trim="item.Keyword"
          placeholder="请输入钉钉关键词"
        ></el-input>
      </el-form-item>
      <el-form-item label="钉钉群名" prop="GroupName">
        <el-input
          v-model.trim="item.GroupName"
          placeholder="请输入钉钉群名"
        ></el-input>
      </el-form-item>
      <el-form-item label="Webhook" prop="Webhook">
        <el-input
          v-model.trim="item.Webhook"
          :autosize="{ minRows: 3 }"
          type="textarea"
          placeholder="请输入Webhook"
        ></el-input>
      </el-form-item>
      <el-form-item label="静默时间" class="mar-no">
          <el-input v-model="item.Slient"></el-input>
          <div style="font-size: 13px; color: #758697; line-height: 30px">
            静默时间以逗号分割，格式为00:00-08:00,18:00-23:59
          </div>
        </el-form-item>
      <el-form-item label="备注" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 3 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: {},
      rules: {
        Name: [
          { required: true, message: "提醒名称不能为空", trigger: "blur" },
        ],
        Code: [
          { required: true, message: "提醒编码不能为空", trigger: "blur" },
        ],
        Keyword: [
          { required: true, message: "提醒关键词不能为空", trigger: "blur" },
        ],
        GroupName: [
          { required: true, message: "钉钉群名不能为空", trigger: "blur" },
        ],
        Webhook: [
          { required: true, message: "Webhook不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID ? `dingtalkconfig/${itemData.ID}` : "dingtalkconfig",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
